import React from "react";
import { useMatch, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import Countries from "src/data/countries.json";
import { Icon } from "@iconify/react";

import { Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { Form, FormikProvider, useFormik } from "formik";

import {
  acceptableCurrencyList,
  companyFormTabs,
  getCompanyDefaultValues,
} from "./company.constants";
import { companyFormValidationSchema } from "src/util/validationSchemas";
import {
  availablePaymentGatewayListUrl,
  companyUrl,
  getCompanyUrlId,
} from "src/react-query/endPoints";
import {
  useGetDetail,
  useGetPaymentGatewayDetails,
  useGetPaymentGatewayList,
  useList,
  useMutate,
} from "src/hooks/useFetch.hook";
import { useCallback, useEffect, useState } from "react";
import { LoadingButton, TabContext, TabPanel } from "@mui/lab";
import { Loader } from "../Loader";
import { is } from "src/util/is";
import Address from "src/common/components/Address";
import { alertSlice } from "src/store/alert/alert.slice";
import { useDispatch } from "react-redux";
import { useDomainConfig } from "src/hooks/useDomainConfig";
import { useMutation } from "@tanstack/react-query";
import { iconUpload } from "src/components/ServiceRequest/serviceRequest.hook";
import { UploadImage } from "./uploadImage";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import TeamFinanceForm from "src/components/Team/TeamFinanceForm";
import {
  possibleBusinessTypes,
} from "src/components/Team/teams.constants";
import DeleteIcon from "@iconify/icons-eva/minus-fill";
import AddIcon from "@iconify/icons-eva/plus-fill";

export const CompanyForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const domainConfig = useDomainConfig();
  const { companyId } = useParams();
  const { mutate, isLoading } = useMutate("companyList");
  const [selectedTab, setSelectedTab] = useState("general");
  const {
    mutate: availablePaymentGatewayList,
  } = useGetPaymentGatewayList();
  const isCreateCompany = useMatch("/company/new");
  const { data: company, isFetching } = useGetDetail("company", {
    id: companyId,
  });
  const iconList = [
    {
      iconTitle: "Grey Icon",
      iconKey: "greyIcon",
    },
    {
      iconTitle: "Green  Icon",
      iconKey: "greenIcon",
    },
    {
      iconTitle: "Red Icon",
      iconKey: "redIcon",
    },
    {
      iconTitle: "Icon",
      iconKey: "icon",
    },
  ];
  // const [savedPaymentGatewayId,setSavedPaymentGatewayId] = useState(null);
  // const { data: paymentGatewayDetails, isFetching:isFetchingPaymentGatwayDetails } = useGetPaymentGatewayDetails(isCreateCompany,savedPaymentGatewayId)
  // const domainProviderMap = {
  //   amiktechnologies: { name: "AMIK Technologies" },
  //   moveonev: { name: "MoveonEV" },
  //   avvtech: { name: "AvvTech" },
  // };
  const domainProviderMap = {
    amiktechnologies: {
      name: "AMIK Technologies",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
      },
      countryCode: "+91",
    },
    moveonev: {
      name: "MoveonEV",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/moveonev.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/moveonev.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/moveonev.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/moveonev.png",
      },
      countryCode: "+91",
    },
    avvtech: {
      name: "AvvTech",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
      },
      countryCode: "+1",
    },
  };

  const [gatewayList, setGatewayList] = useState([]);
  const [showCustomDomainInput, setShowCustomDomainInput] = useState(false);

  const onSubmit = async (companyData, { setSubmitting, setErrors }) => {
    try {
      const {
        companyProtocolType,
        financeConfig,
      } = companyData;
      const {
        actions: { setAlert },
      } = alertSlice;

      let finalCompanyData = {};

      //IMPORTANT VALIDATIONS

      // const zeroValue=(val)=>parseFloat(val)===0
      // if(zeroValue(transactionPercent) || zeroValue(taxPercent)){
      //   let errorsUpd = {...errors,transactionPercent:zeroValue(transactionPercent)?"Specify a value greater than zero":"",taxPercent:zeroValue(taxPercent)?"Specify a value greater than zero":""}
      //   setErrors(errorsUpd);
      //   dispatch(
      //     setAlert({
      //       open: true,
      //       message: `Specify a value greater than zero for the percentages`,
      //       severity: "error",
      //     })
      //   );
      //   setSubmitting(false);
      //   return
      // }

      // Removed validation for paymentGatewayDetailsId === 0 to allow "None" option

      if (companyProtocolType === "ocpi") {
        const {
          cpoToken,
          emspToken,
          endpoint,
          partyId,
          role,
          countryCode,
          logo,
          name,
          active,
          domain,
          provider,
        } = companyData;

        if (!cpoToken || !emspToken || !endpoint || !partyId) {
          const errorsUpd = {
            cpoToken: !cpoToken ? "CPO Token is required" : "",
            emspToken: !emspToken ? "EMSP Token is required" : "",
            endpoint: !endpoint ? "Endpoint is required" : "",
            partyId: !partyId ? "Party ID is required" : "",
          };
          setErrors(errorsUpd);
          dispatch(
            setAlert({
              open: true,
              message: "CPO Token, EMSP Token, Endpoint, and Party ID are required for OCPI",
              severity: "error",
            })
          );
          setSubmitting(false);
          return;
        }

        let formattedLogo = logo;
        if (formattedLogo && typeof formattedLogo === "string") {
          formattedLogo = {
            url: formattedLogo,
            category: "OPERATOR",
            type: "jpeg",
          };
        }

        finalCompanyData = {
          name,
          active,
          companyProtocolType: "ocpi",
          cpoToken,
          emspToken,
          endpoint,
          role,
          countryCode,
          logo: formattedLogo,
          address: null,
          subscriptionId: companyData.subscriptionId || 1,
          domain: domain || domainConfig.domain || "amiktechnologies",
          provider: {
            ...provider,
            name: provider?.name || name,
          },
        };

        if (isCreateCompany) {
          finalCompanyData.partyId = partyId;
        }
      } else {
        // ==================== OCPP ISOLATED SUBMISSION ====================
        const {
          street,
          houseNumber,
          zipCode,
          city,
          state,
          country,
          locationLatitude,
          locationLongitude,
          addressId,
          paymentGatewayDetailsId,
          name,
        } = companyData;
        
        const updatedFinanceConfig = {
          ...financeConfig,
          payment_gateway_details: {
            ...financeConfig.payment_gateway_details,
            payment_gateway_details_id:
              is.empty(
                financeConfig?.payment_gateway_details?.payment_gateway_details_id
              ) ||
              financeConfig?.payment_gateway_details
              ?.payment_gateway_details_id === ""
                ? null
                : financeConfig?.payment_gateway_details
                ?.payment_gateway_details_id,
          },
        };

        finalCompanyData = {
          ...companyData,
          address: {
            street,
            houseNumber,
            zipCode,
            city,
            state,
            country,
            lat: locationLatitude,
            lng: locationLongitude,
          },
          financeConfig: updatedFinanceConfig,
        };

        const updatedProvider = await UploadProviderImagesToAWS();
        finalCompanyData.provider = {
          ...updatedProvider,
          name: companyData.provider?.name || name,
        };
        
        if (!isCreateCompany && !is.nullOrUndefined(companyId)) {
          if (finalCompanyData.address) {
            finalCompanyData.address.addressId = addressId;
          }
          delete finalCompanyData.addressId;
        }
      }

      const mutateObject = {
        url: isCreateCompany ? companyUrl : getCompanyUrlId(companyId),
        method: isCreateCompany ? "POST" : "PUT",
      };

      mutate(
        {
          url: mutateObject.url,
          method: mutateObject.method,
          body: {
            company: finalCompanyData,
          },
        },
        {
          onSuccess,
          onError: (error) => {
            console.error("Mutation error:", error);
            const errorMessage =
              error?.response?.data?.message ||
              error?.message ||
              "Failed to save company";
            dispatch(
              setAlert({
                open: true,
                message: errorMessage,
                severity: "error",
              })
            );
            setSubmitting(false);
          },
        }
      );
    } catch (error) {
      console.error("CompanyForm: Error submitting company data:", {
        error: error.message,
        stack: error.stack,
        companyData: {
          companyName: companyData.companyName,
          companyId: companyData.companyId,
        },
      });
      setSubmitting(false);
    }
  };

  const onSuccess = () => navigate("/company");

  const formik = useFormik({
    initialValues: getCompanyDefaultValues(),
    validationSchema: companyFormValidationSchema,
    onSubmit,
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
    setErrors,
  } = formik;

  const UploadProviderImagesToAWS = async () => {
    return new Promise(async (res) => {
      const provider = values["provider"];

      for await (let data of iconList) {
        const icon = provider[data?.iconKey];
        if (icon && !icon.startsWith("http")) {
          const response = await iconUpload({ image: provider[data?.iconKey] });
          provider[data.iconKey] = response.data.data;
        }
      }
      res(provider);
    });
  };

  useEffect(() => {
    if (company) {
      let {
        address,
        paymentGatewayDetailsId,
        paymentCurrency,
        financeConfig,
        provider,
        companyProtocolType,
        token,
        cpoToken,
        emspToken,
        endpoint,
        partyId,
        role,
        countryCode,
        logo,
        ...rest
      } = company;

      const zipcode = address?.zipcode;
      const lat = address?.lat;
      const lng = address?.lng;

      let parsedProvider = provider;
      if (typeof provider === 'string') {
        try {
          parsedProvider = JSON.parse(provider);
        } catch (e) {
          console.error("Failed to parse provider JSON", e);
        }
      }

      const companyValues = {
        ...rest,
        ...address,
        zipCode: zipcode,
        locationLatitude: lat,
        locationLongitude: lng,
        paymentGatewayDetailsId,
        paymentCurrency: paymentCurrency || "INR",
        active: rest.active === true || rest.active === "Y" || rest.active === "true" ? "Y" : "N",
        provider: parsedProvider || getCompanyDefaultValues().provider,
        companyProtocolType,
        token: token || "",
        cpoToken: cpoToken || "",
        emspToken: emspToken || "",
        endpoint: endpoint || null,
        partyId: partyId || null,
        role: role?.toUpperCase() || "CPO",
        countryCode: countryCode?.toUpperCase() || "IN",
        logo: logo || "",
        financeConfig: financeConfig
          ? {
            charger_payment_details: {
              monthly_payment:
                financeConfig?.charger_payment_details?.monthly_payment ??
                true,
              dc_charges_monthly:
                financeConfig?.charger_payment_details?.dc_charges_monthly ??
                349,
              ac_charges_monthly:
                financeConfig?.charger_payment_details?.ac_charges_monthly ??
                249,
              dc_charges_annual:
                financeConfig?.charger_payment_details?.dc_charges_annual ??
                "",
              ac_charges_annual:
                financeConfig?.charger_payment_details?.ac_charges_annual ??
                "",
              tax: financeConfig?.charger_payment_details?.tax ?? 18,
              other_fixed_cost:
                financeConfig?.charger_payment_details?.other_fixed_cost ??
                "",
            },
            transaction_payment_details: {
              pg_charges_bearer:
                financeConfig?.transaction_payment_details
                  ?.pg_charges_bearer ?? "EV",
              payment_gateway_percent:
                financeConfig?.transaction_payment_details
                  ?.payment_gateway_percent ?? 2.36,
              tax:
                financeConfig?.transaction_payment_details?.tax ?? 18,
            },
            payout_details: {
              payout_rule:
                financeConfig?.payout_details?.payout_rule ?? 3,
              tax_bearer:
                financeConfig?.payout_details?.tax_bearer ?? "CM",
              tax: financeConfig?.payout_details?.tax ?? 18,
              chargemiles_commission_in_percent:
                financeConfig?.payout_details
                  ?.chargemiles_commission_in_percent ?? true,
              chargemiles_commission_percent:
                financeConfig?.payout_details
                  ?.chargemiles_commission_percent ?? 5,
              chargemiles_commission_cost:
                financeConfig?.payout_details?.chargemiles_commission_cost ??
                "",
            },
            payment_gateway_details: {
              payment_gateway_details_id:
                financeConfig?.payment_gateway_details
                  ?.payment_gateway_details_id ?? null,
            },
          }
          : getCompanyDefaultValues().financeConfig,
      };
      resetForm({ values: companyValues });
    }
  }, [company, resetForm]);

  useEffect(() => {
    const mutateObject = {
      url: availablePaymentGatewayListUrl,
      method: "GET",
    };
    availablePaymentGatewayList(mutateObject, {
      onSuccess: (data) => {
        const { data: list } = data;
        if (!is.empty(list)) {
          setGatewayList(list);
        }
      },
    });
  }, []);

  const handleTabChange = (e, tab) => {
    setSelectedTab(tab);
  };

  const filteredTabs = companyFormTabs.filter((tab) => {
    if (values.companyProtocolType === "ocpi" && tab.value === "finance")
      return false;
    return true;
  });

  if (isFetching) {
    return <Loader />;
  }

  if (!isCreateCompany && is.empty(company)) {
    navigate("/company");
    return null;
  }

  return (
    <>
      <TabContext value={selectedTab}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <RootTabStyle
            indicatorColor="transparent"
            centered
            length={filteredTabs.length}
            onChange={handleTabChange}
          >
            {filteredTabs.map((tab) => (
              <RootTabItemStyles
                key={tab.value}
                value={tab.value}
                label={tab.label}
              />
            ))}
          </RootTabStyle>
        </Stack>

        <Card sx={{ p: 2 }}>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              id="company"
              noValidate
              onSubmit={handleSubmit}
            >
              {/* ==================== GENERAL TAB ==================== */}
              <TabPanel value="general">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small">
                      <TextField
                        required
                        id="outlined-basic"
                        label="Company Name"
                        size="small"
                        {...getFieldProps("name")}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="company-type-label">Company Type</InputLabel>
                      <Select
                        labelId="company-type-label"
                        id="company-type"
                        label="Company Type"
                        {...getFieldProps("companyProtocolType")}
                        disabled={!isCreateCompany}
                      >
                        <MenuItem value="ocpp">OCPP</MenuItem>
                        <MenuItem value="ocpi">OCPI</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values.companyProtocolType !== "ocpi" && (
                    <>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="demo-simple-select-label">
                            Subscription Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Subscription Type"
                            {...getFieldProps("subscriptionId")}
                          >
                            <MenuItem value={1}>Basic</MenuItem>
                            <MenuItem value={2}>Chargemiles</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* // Domain select field */}
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="domain-label">Domain</InputLabel>
                {/* <Select
                  labelId="domain-label"
                  id="domain-select"
                  label="Domain"
                  value={
                    domainProviderMap[values.domain] ? values.domain : "custom"
                  }
                  onChange={(e) => {
                    const selectedDomain = e.target.value;
                    if (selectedDomain === "custom") {
                      setShowCustomDomainInput(true);
                      setFieldValue("domain", "");
                      setFieldValue("provider", {
                        ...values.provider,
                        name: "",
                      });
                    } else {
                      setShowCustomDomainInput(false);
                      setFieldValue("domain", selectedDomain);
                      setFieldValue("provider", {
                        ...values.provider,
                        name: domainProviderMap[selectedDomain].name,
                      });
                    }
                  }}
                  error={Boolean(touched.domain && errors.domain)}
                >
                  {Object.keys(domainProviderMap).map((domain) => (
                    <MenuItem key={domain} value={domain}>
                      {domain}
                    </MenuItem>
                  ))}
                  <MenuItem value="custom">Other (enter custom)</MenuItem>
                </Select> */}
                          <Select
                            labelId="domain-label"
                            id="domain-select"
                            label="Domain"
                            value={
                              domainProviderMap[values.domain] ? values.domain : "custom"
                            }
                            onChange={(e) => {
                              const selectedDomain = e.target.value;
                              if (selectedDomain === "custom") {
                                setShowCustomDomainInput(true);
                                setFieldValue("domain", "");
                                setFieldValue("provider", {
                                  name: "",
                                  greyIcon: "",
                                  greenIcon: "",
                                  redIcon: "",
                                  icon: "",
                                  countryCode: "+91",
                                });
                              } else {
                                setShowCustomDomainInput(false);
                                setFieldValue("domain", selectedDomain);
                                setFieldValue("provider", {
                                  name: domainProviderMap[selectedDomain].name,
                                  ...domainProviderMap[selectedDomain].icons,
                                  countryCode:
                                    domainProviderMap[selectedDomain].countryCode,
                                });
                              }
                            }}
                            error={Boolean(touched.domain && errors.domain)}
                          >
                            {Object.keys(domainProviderMap).map((domain) => (
                              <MenuItem key={domain} value={domain}>
                                {domain}
                              </MenuItem>
                            ))}
                            <MenuItem value="custom">Other (enter custom)</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* Custom domain input */}
                      {(showCustomDomainInput ||
                        (values.domain && !domainProviderMap[values.domain])) && (
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth size="small">
                            <TextField
                              label="Domain"
                              size="small"
                              value={values.domain}
                              onChange={(e) => {
                                setFieldValue("domain", e.target.value);
                                setShowCustomDomainInput(e.target.value !== "");
                              }}
                              error={Boolean(touched.domain && errors.domain)}
                              helperText={touched.domain && errors.domain}
                            />
                          </FormControl>
                        </Grid>
                      )}
                      {/* Provider name field */}
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            label="Provider Name"
                            size="small"
                            value={values.provider?.name || ""}
                            onChange={(e) => {
                              setFieldValue("provider", {
                                ...values.provider,
                                name: e.target.value,
                              });
                            }}
                            error={Boolean(
                              touched.provider?.name && errors.provider?.name
                            )}
                            helperText={
                              touched.provider?.name && errors.provider?.name
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="payment-type">Payment Type</InputLabel>
                          <Select
                            labelId="payment-type"
                            id="demo-simple-select"
                            label="Payment Type"
                            {...getFieldProps("paymentConfirmationNo")}
                          >
                            <MenuItem value="card">Card</MenuItem>
                            <MenuItem value="upi">UPI</MenuItem>
                            <MenuItem value="cash">Cash</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={Boolean(
                            touched.paymentCurrency && errors.paymentCurrency
                          )}
                        >
                          <InputLabel id="demo-simple-select-label">
                            Payment Currency Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Payment Currency Typee"
                            {...getFieldProps("paymentCurrency")}
                            value={values["paymentCurrency"]}
                          >
                            {acceptableCurrencyList.map(({ value, title }, index) => (
                                <MenuItem
                                  value={value}
                                  key={`${value}-${index}-currency-${title}`}
                                >
                                  {title}
                                </MenuItem>
                              ))}
                          </Select>
                          {touched.paymentCurrency && (
                            <FormHelperText>{errors.paymentCurrency}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="demo-simple-select-label">
                            Payment Gateway
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Payment Gateway"
                            value={values.paymentGatewayDetailsId ?? ""}
                            onChange={(event) => {
                              const value = event.target.value;
                              if (value === "") {
                                // "None" option selected - set to null
                                setFieldValue("paymentGatewayDetailsId", null);
                                setFieldValue("paymentGatewayId", "1");
                              } else {
                                const selectedGateway = gatewayList.find(
                                  (gateway) => gateway.id === value
                                );
                                if (selectedGateway) {
                                  setFieldValue(
                                    "paymentGatewayDetailsId",
                                    selectedGateway.id
                                  );
                                  setFieldValue(
                                    "paymentGatewayId",
                                    selectedGateway.payment_gateway_id
                                  );
                                }
                              }
                            }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {gatewayList.map((value, index) => (
                              <MenuItem
                                value={value?.id}
                                key={`${value?.id}-${index}-gateway-${value?.name}`}
                              >
                                {value?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required
                            id="outlined-basic"
                            label="Tax Percentage"
                            size="small"
                            type="number"
                            inputProps={{ step: "0.01", min: 0, max: 100 }}
                            {...getFieldProps("taxPercent")}
                            error={Boolean(touched.taxPercent && errors.taxPercent)}
                            helperText={touched.taxPercent && errors.taxPercent}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required
                            id="outlined-basic"
                            label="Transaction Percentage"
                            size="small"
                            type="number"
                            inputProps={{ step: "0.01", min: 0, max: 100 }}
                            {...getFieldProps("transactionPercent")}
                            error={Boolean(
                              touched.transactionPercent && errors.transactionPercent
                            )}
                            helperText={
                              touched.transactionPercent && errors.transactionPercent
                            }
                          />
                        </FormControl>
                      </Grid>
                    </>
                  )}
                  {values.companyProtocolType === "ocpi" && (
                    <>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required
                            id="cpoToken"
                            label="CPO Token"
                            size="small"
                            {...getFieldProps("cpoToken")}
                            error={Boolean(touched.cpoToken && errors.cpoToken)}
                            helperText={touched.cpoToken && errors.cpoToken}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required
                            id="emspToken"
                            label="EMSP Token"
                            size="small"
                            {...getFieldProps("emspToken")}
                            error={Boolean(touched.emspToken && errors.emspToken)}
                            helperText={touched.emspToken && errors.emspToken}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required
                            id="endpoint"
                            label="Endpoint"
                            size="small"
                            {...getFieldProps("endpoint")}
                            error={Boolean(touched.endpoint && errors.endpoint)}
                            helperText={touched.endpoint && errors.endpoint}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            required={isCreateCompany}
                            disabled={!isCreateCompany}
                            id="partyId"
                            label="Party ID"
                            size="small"
                            {...getFieldProps("partyId")}
                            error={Boolean(touched.partyId && errors.partyId)}
                            helperText={touched.partyId && errors.partyId}
                            inputProps={{ maxLength: 3 }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="role-label">Role</InputLabel>
                          <Select
                            labelId="role-label"
                            id="role"
                            label="Role"
                            {...getFieldProps("role")}
                          >
                            <MenuItem value="CPO">CPO</MenuItem>
                            <MenuItem value="EMSP">EMSP</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="country-code-label">
                            Country Code
                          </InputLabel>
                          <Select
                            labelId="country-code-label"
                            id="country-code"
                            label="Country Code"
                            {...getFieldProps("countryCode")}
                          >
                            {Countries.map((country) => (
                              <MenuItem key={country.code} value={country.code}>
                                {country.name} ({country.code})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            id="logo"
                            label="Logo URL"
                            size="small"
                            {...getFieldProps("logo")}
                          />
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </Grid>
                {values.companyProtocolType !== "ocpi" && (
                  <>
                    <Address
                      getFieldProps={getFieldProps}
                      setFieldValue={setFieldValue}
                      formValues={values}
                      hide={true}
                      displayedFor="company"
                    />
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={12}>
                        <Typography variant="subtitle1" className="mb-2">
                          Company Info
                        </Typography>
                        <Divider />
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            size="small"
                            id="outlined-basic"
                            label="Root User"
                            {...getFieldProps("rootUser")}
                            disabled={!isCreateCompany}
                            error={Boolean(touched.rootUser && errors.rootUser)}
                            helperText={touched.rootUser && errors.rootUser}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            id="outlined-basic"
                            label="Email Address"
                            size="small"
                            disabled={!isCreateCompany}
                            {...getFieldProps("emailId")}
                            error={Boolean(touched.emailId && errors.emailId)}
                            helperText={touched.emailId && errors.emailId}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} lg={12}>
                        <Typography variant="subtitle1" className="mb-2">
                          Add Icons
                        </Typography>
                        <Divider sx={{ marginBottom: "8px" }} />
                      </Grid>
                      {/* {iconList.map((data) => (
              <Grid item xs={12} lg={3} key={data.iconKey}>
                <UploadImage
                  getFieldProps={getFieldProps}
                  setFieldValue={setFieldValue}
                  formValues={values}
                  iconKey={data.iconKey}
                  iconTitle={data.iconTitle}
                  iconUrl={values.provider?.[data.iconKey] || ""}
                />
              </Grid>
            ))} */}
                      {iconList.map((data) => (
                        <Grid item xs={12} lg={3} key={data.iconKey}>
                          <UploadImage
                            getFieldProps={getFieldProps}
                            setFieldValue={setFieldValue}
                            formValues={values}
                            iconKey={data.iconKey}
                            iconTitle={data.iconTitle}
                            iconUrl={values.provider?.[data.iconKey] || ""}
                            disabled={
                              domainProviderMap[values.domain] && !showCustomDomainInput
                            }
                          />
                          {domainProviderMap[values.domain] && !showCustomDomainInput && (
                              <Typography variant="caption" color="textSecondary">
                                Icon is set by domain selection
                              </Typography>
                            )}
                        </Grid>
                      ))}
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={12}>
                        <Typography variant="subtitle1" className="mb-2">
                          Comments
                        </Typography>
                        <Divider />
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth size="small">
                          <TextField
                            sx={{ m: 1, width: 500 }}
                            id="outlined-multiline-static"
                            multiline
                            rows={4}
                            {...getFieldProps("comments")}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </>
                )}
              </TabPanel>



               {/* ==================== FINANCE CONFIGURATION TAB ==================== */}
              {values.companyProtocolType !== "ocpi" && (
                <TabPanel value="finance">
                  <Box mb={2}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Default finance configuration for teams created under this
                      company. Individual teams can override these settings to have their own finance configuration.
                    </Typography>
                  </Box>
                  <TeamFinanceForm
                    formik={formik}
                    permissions={{ isReadOnly: false }}
                    paymentDetails={{}}
                  />
                </TabPanel>
              )}

              {/* ==================== SUBMIT BUTTONS ==================== */}
              {selectedTab !== "members" && (
                <Grid container mt={3}>
                  <Grid item xs={6} lg={6}>
                    <Stack direction="row" spacing={2}>
                      <Button
                        size="medium"
                        type="button"
                        variant="outlined"
                        component={RouterLink}
                        to="/company"
                        startIcon={<Icon icon="eva:close-outline" />}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        Cancel
                      </Button>
                      <LoadingButton
                        size="medium"
                        type="submit"
                        variant="contained"
                        loading={isSubmitting || isLoading}
                        startIcon={<Icon icon="eva:save-outline" />}
                        onClick={() => {
                           if (Object.keys(errors).length > 0) {
                             const errorFields = Object.keys(errors).join(", ");
                             dispatch(alertSlice.actions.setAlert({
                               open: true,
                               message: `Validation errors in: ${errorFields}`,
                               severity: "error"
                             }));
                           }
                        }}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        {isSubmitting || isLoading ? "Saving..." : "Save Changes"}
                      </LoadingButton>
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </Form>
          </FormikProvider>
        </Card>
      </TabContext>
    </>
  );
};
